import { gql } from '@apollo/client'
import { DTVFragment } from '../fragments/dtv.fragments'
import {
    getChildElementQuery,
    getChildElementQueryForSetProjectContentItemElements,
} from '../queries/projectElements.queries'

export const ReorderFamilyContent = gql`
    mutation reorderFamilyContent(
        $reOrderFamilyContentInput: ViewItemReorderInput!
    ) {
        reOrderFamilyContent(input: $reOrderFamilyContentInput) {
            ...dtvFragment
        }
    }
    ${DTVFragment}
`

export const SetProjectContentItemIsHidden = gql`
    mutation setProjectContentItemIsHidden(
        $SetProjectContentItemIsHiddenInput: SetProjectContentItemIsHiddenInput!
    ) {
        setProjectContentItemIsHidden(
            input: $SetProjectContentItemIsHiddenInput
        ) {
            ...dtvFragment
        }
    }
    ${DTVFragment}
`

export const SetProjectContentItemIsHiddenCKE = gql`
    mutation setProjectContentItemIsHidden(
        $SetProjectContentItemIsHiddenInput: SetProjectContentItemIsHiddenInput!
    ) {
        setProjectContentItemIsHidden(
            input: $SetProjectContentItemIsHiddenInput
        ) {
            id
        }
    }
`

export const SetProjectContentItemIsHiddenBulkCKE = gql`
    mutation setProjectContentItemIsHiddenBulk(
        $inputs: [SetProjectContentItemIsHiddenInput!]!
        $partType: String
    ) {
        setProjectContentItemIsHiddenBulk(
            inputs: $inputs
            partType: $partType
        ) {
            id
        }
    }
`

export const SetProjectElementNodeIsDeactivatedMutation = gql`
    mutation setProjectElementNodeIsDeactivated(
        $DeactivateProductTypeInput: DeactivateProductTypeInput!
    ) {
        setProjectElementNodeIsDeactivated(input: $DeactivateProductTypeInput) {
            id
            elementId
            baseElementId
            nodeOrder
            isInProject
            elementType
            text
            treePath
            parentNodeId
            projectId
            isDeactivated
            isHidden
            parentTreePath
            isSearchResult
            hasChildren
            isLastSubAssembly
            isBestPractice
            isGlobalBestPractice
            hasBestPractice
            isImportedToProject
            importedToProjectId
            isBasedFromImportedNode
            isProjectOnly
            isBpPublished
        }
    }
`

export const ReorderProductTypeContent = gql`
    mutation reOrderPTContent(
        $reOrderPTContentInput: ViewItemReorderPTPInput!
    ) {
        reOrderPTContent(input: $reOrderPTContentInput) {
            ...dtvFragment
        }
    }
    ${DTVFragment}
`

export const AddNewContentItem = (depth: number) => {
    const elements = getChildElementQuery(depth)
    return gql`
        mutation addProjectContentItem($input: AddProjectContentItemInput!, 
            $partType: TemplateItemPartType!,
            $rootArticleContentItemIds: [String],
            $productFamilyId: String!,
            $projectId: String!
            $isTrackChangeToggleOn: Boolean
            ) {
            addProjectContentItem(input: $input
                isTrackChangeToggleOn: $isTrackChangeToggleOn) {
                documentTemplateView {
                    ...dtvFragment
                }
                projectNuggets {
                    id
                    projectProductTypeProperties {
                        id
                        name
                    }
                    projectElementMetadata {
                        baseElementId
                    }
                    contentItemNodes (input: {
                        templateItemPartType: $partType,
                        rootArticleContentItemId: $rootArticleContentItemIds
                        productFamilyId: $productFamilyId,
                        projectId:$projectId
                    }) {
                        id
                        comments
                        textType
                        contentType
                        ${elements}
                    }
                }
                contentItemNodes (input: {
                    templateItemPartType: $partType,
                    rootArticleContentItemId: $rootArticleContentItemIds
                    productFamilyId: $productFamilyId,
                    projectId:$projectId
                }) {
                    id
                    comments
                    textType
                    contentType
                    isBestPractice
                    isGlobalBestPractice
                    ${elements}
                }
            }
        }
        ${DTVFragment}
    `
}

export const AddNewContentItemForCKE = () => {
    return gql`
        mutation addProjectContentItem(
            $input: AddProjectContentItemInput!
            $isTrackChangeToggleOn: Boolean
        ) {
            addProjectContentItem(
                input: $input
                isTrackChangeToggleOn: $isTrackChangeToggleOn
            ) {
                projectElementId
            }
        }
    `
}

export const AddNewSustainabilityTopic = (depth: number) => {
    const elements = getChildElementQuery(depth)
    return gql`
        mutation addProjectContentItem($input: AddProjectContentItemInput!, 
            $partType: TemplateItemPartType!,
            $rootArticleContentItemIds: [String],
            $productFamilyId: String!,
            $projectId: String!
            $isTrackChangeToggleOn: Boolean
            ) {
            addProjectContentItem(input: $input
                isTrackChangeToggleOn: $isTrackChangeToggleOn) {
                projectElementId
                documentTemplateView {
                    ...dtvFragment
                }
                contentItemNodes (input: {
                    templateItemPartType: $partType,
                    rootArticleContentItemId: $rootArticleContentItemIds
                    productFamilyId: $productFamilyId,
                    projectId:$projectId
                }) {
                    id
                    comments
                    textType
                    contentType
                    ${elements}
                }
            }
        }
        ${DTVFragment}
    `
}

export const SetProjectContentItemElements = (depth: number) => {
    const elements = getChildElementQueryForSetProjectContentItemElements(depth)
    return gql`
    mutation setProjectContentItemElements(
        $input: SetProjectContentItemElementsInput!, $partType: TemplateItemPartType!, $rootArticleContentItemIds: [String],
        $productFamilyId: String!,
        $projectId: String!
        $isTrackChangeToggleOn: Boolean
        $isResetAllOptions: Boolean


    ) {
        setProjectContentItemElements(input: $input,
            isTrackChangeToggleOn: $isTrackChangeToggleOn,
            isResetAllOptions: $isResetAllOptions
            ) {
            contentItemNodes (input: {
                templateItemPartType: $partType,
                rootArticleContentItemId: $rootArticleContentItemIds
                productFamilyId: $productFamilyId,
                projectId:$projectId,
            }) {
                id
                comments
                parentComments
                textType
                isBestPractice
                isGlobalBestPractice
                ${elements}
            }
        }
    }
`
}

export const SetProjectContentItemElementsCKE = gql`
    mutation setProjectContentItemElements(
        $input: SetProjectContentItemElementsInput!
        $isTrackChangeToggleOn: Boolean
        $isResetAllOptions: Boolean
    ) {
        setProjectContentItemElements(
            input: $input
            isTrackChangeToggleOn: $isTrackChangeToggleOn
            isResetAllOptions: $isResetAllOptions
        ) {
            projectElementId
        }
    }
`

export const SetProjectContentItemViewElements = (depth: number) => {
    const elements = getChildElementQueryForSetProjectContentItemElements(depth)
    return gql`
    mutation setProjectContentItemElements(
        $input: SetProjectContentItemElementsInput!
        $partType: TemplateItemPartType!
        $projectId: String!
        $isTrackChangeToggleOn: Boolean
        $isResetAllOptions: Boolean
    ) {
        setProjectContentItemElements(
            input: $input
            isTrackChangeToggleOn: $isTrackChangeToggleOn
            isResetAllOptions: $isResetAllOptions
        ) {
            contentItemViewNodes(
                input: {
                    projectId: $projectId
                    templateItemPartType: $partType
                    isTrackChangeToggleOn: $isTrackChangeToggleOn
                }
            ) {
                id
                documentTemplateViewId
                productFamilyId
                projectId
                contentType
                productFamilyContentId
                comments
                parentComments
                textType
                isProductGroup
                isBestPractice
                isGlobalBestPractice
                ${elements}
                partType
                type
                dtvParentId
                levelOfSpecificationTag
                order
                dtvItemId
                isHidden
                isUserAdded
                propertyRefId
                paragraphOrder
                isSustainabilityContentItem
                isForProductType
                isProductType
                isManufacturers
                isBOD
                isSharedProductTypeProperty
                isProductGroupHasMultipleProductTypes
                dtvContentItemParentId
                isSharedProperty
                isAddedToProject
                pillId
                refBodItemId
                isPillSelected
                isImported
                documentTemplateViewId
                drawingDesignation
                __typename
            }
        }
    }
`
}

export const PromoteDemotContentItem = gql`
    mutation promoteDemoteContent(
        $promoteDemonteContentInput: PromoteDemoteInput!
    ) {
        promoteDemoteContent(input: $promoteDemonteContentInput) {
            ...dtvFragment
        }
    }
    ${DTVFragment}
`

export const UpdateBestPracticeElements = (depth: number) => {
    const elements = getChildElementQueryForSetProjectContentItemElements(depth)
    return gql`
    mutation updateBestPracticeElements(
        $input: SetProjectContentItemElementsInput!,
        $partType: TemplateItemPartType!,
        $rootArticleContentItemIds: [String],
        $productFamilyId: String!,
        $bestPracticeInput: BestPracticeInput!,
        $projectId: String!
        $isTrackChangeToggleOn: Boolean
        $isResetAllOptions: Boolean
    ) {
        updateBestPracticeElements(input: $input,
            isTrackChangeToggleOn: $isTrackChangeToggleOn,
            isResetAllOptions: $isResetAllOptions,
            bestPracticeInput:$bestPracticeInput
            ) {
            contentItemNodes (input: {
                templateItemPartType: $partType,
                rootArticleContentItemId: $rootArticleContentItemIds
                productFamilyId: $productFamilyId,
                projectId:$projectId,
            }) {
                id
                comments
                parentComments
                textType
                isBestPractice
                isGlobalBestPractice
                ${elements}
            }
        }
    }
`
}
